import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../entities/ExceptionEntity";
import UserEntity from "../../entities/UserEntity";
import BucketRepository from "../../repositories/BucketRepository";

interface props { bucketRepository: BucketRepository }

@injectable()
export default class GetUsersInBucketUseCase {
    _bucketRepository: BucketRepository;

    constructor(_: props) {
        this._bucketRepository = _.bucketRepository;
    }

    public call = async (bucketId: number, page: number, perPage: number): Promise<Either<ExceptionEntity, UserEntity[]>> => {
        return await this._bucketRepository.getUsersInBucket(bucketId, page, perPage);
    }
}

export const GetUsersInBucketUseCaseName = "GetUsersInBucketUseCaseName";
